import { useEffect } from "react";
import { useSiteConfigStore, selectProductName } from "@/stores/siteConfigStore";

/**
 * Sets `document.title` while the component is mounted. Supports the same
 * `{company}` placeholder the Vue router used (resolved via siteConfigStore).
 */
export function usePageTitle(title: string | undefined) {
  const productName = useSiteConfigStore(selectProductName);

  useEffect(() => {
    if (!title) return;
    const resolved = title.replace("{company}", productName || "");
    const previous = document.title;
    document.title = resolved;
    return () => {
      document.title = previous;
    };
  }, [title, productName]);
}
